module.exports = __webpack_public_path__ + "static/media/handStrength3Right.30622b2a.png";